﻿import React, { ClipboardEvent } from "react";
import ReactDOM from "react-dom";
import { renderToString } from 'react-dom/server';
import { DirectLine, DirectLineOptions } from "botframework-directlinejs";
import {Store, AnyAction} from "redux";
import ReactWebChat, { createStore, StyleOptions } from "botframework-webchat";

import {downscaleImageToDataURLUsingBrowser} from "./downscaleImageToDataURL";
import Droppable from "./Droppable";
import SendFilesModal, { FileItem, _File } from "./SendFilesModal";
import { convertClipboardItemsToFiles, getBrowserName, readFile } from "./helpers";

const { $ } = window;

const AI_RATING_CONTROLLER_SEGMENT = "airating";
const AI_RATING_ACTIONS = ["up", "down"];
const AI_FEEDBACK_MODAL_QUERY_PARAM = "webClientFeedbackModal";
const AI_FEEDBACK_SUBMITTED_MESSAGE = "chime:ai-feedback-submitted";

interface DirectLineAttachment {
    name: string;
    url: string;
    thumbnail?: string;
    size?: number;
}

interface WebChatControlProps {
    token: string;
    conversationId: string;
    userId: string;
    username: string;
    tenantId: string;
    email:string;
    metadata: Map<string, string>;
    styleSet: object;
    playNotificationSound: string;
    startChatAutomatically: string;    
    showPrechatForm: string;
}
function getTimeStamp(){
    return new Date().toISOString();
}

class WebChatControl extends React.Component {
    private directLine: DirectLine|null;
    private token: string;
    readonly props: WebChatControlProps;
    private store: Store<any, AnyAction>;
    private styleSet: StyleOptions;
    readonly sendFileModalId = "#sendFileModal";
    readonly aiFeedbackModalId = "#aiFeedbackModal";
    readonly aiFeedbackFrameId = "aiFeedbackFrame";
    private files: _File[] = [];

    constructor(props: WebChatControlProps) {
        
        super(props);
        console.log(getTimeStamp() + ">> WebChatControl constructor");
        this.props = props;
        this.token = props.token;
        this.directLine = null;

        this.store = createStore({},
            () => (next: (arg0: any) => any): (action: any) => any => action => {
                console.log(getTimeStamp() + " - Direct-line event", action);
                if (action.type === "DIRECT_LINE/QUEUE_INCOMING_ACTIVITY") {
                    // this seems to get hit before the DIRECT_LINE/INCOMING_ACTIVITY event
                    // maybe we can null out the replyToId here and it won't try to look for an activity to reply to
                    // and fail after five seconds
                    console.log(getTimeStamp() + " - queue incoming activity", action.payload);
                    const activity = action.payload.activity;
                    activity.replyToId = null;

                }
                if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY") {
                    console.log(getTimeStamp() + " - incoming activity", action.payload);
                    const {
                        activity: {
                            from: { role },
                            text,
                            type
                        }
                    } = action.payload;
                    if (role === "bot" && type === "message" && this.getSoundEnabled() ) {
                        this.playSound();
                    }
                    if (type === "endOfConversation") {

                        console.log(getTimeStamp() + " - endOfConversation event", type);
                        this.conversationEnded();

                    }
                }
                if (action.type === "DIRECT_LINE/POST_ACTIVITY") {
                    console.log(getTimeStamp() + " - outgoing activity", action.payload);

                    var activity = action.payload.activity;
                    this.patchActivity(activity);
                }
                return next(action);
            }
        );
        
       this.styleSet = {
            ...props.styleSet,
            sendBoxTextWrap: true,
        };
        console.log(getTimeStamp() + " - StyleSet read in: ", this.styleSet);
    }    

    patchActivity(activity: any): any {
        console.log(getTimeStamp() +" - Before patch", activity);
        activity.locale = navigator.language;
        if (activity.conversation) {
            activity.conversation.tenantId = this.props.tenantId;
        }
        if (activity.from) {
            activity.from.tenantId = this.props.tenantId;
        }
        if (!activity.channelData) {
            activity.channelData = {};
        }
        //activity.channelData["Guest.TenantId"] = this.props.tenantId;
        activity.channelData["Guest.Email"] = this.props.email;
        activity.channelData["Guest.Platform"] = getBrowserName();

        this.props.metadata.forEach((value, key) => {
            activity.channelData[key] = value;
        });

        // patch up the activity with any other data that needs it
        console.log(getTimeStamp() +" - After patch", activity);
        return activity;
    }

    private createDirectLine(): DirectLine {
        let options: DirectLineOptions = {
            token: this.token,
            
        };

        var directLine = new DirectLine(options);
        return directLine;
    }
    conversationEnded(){
        console.log(getTimeStamp() + "- Conversation ended");
        // I want to disable the text input box
        const sendBoxes = document.getElementsByClassName("webchat__send-box__main");
        for (let i = 0; i < sendBoxes.length; i++) {
            let sendbox = sendBoxes[i];
            sendbox.setAttribute("style", "display:none");
        }
        // maybe we should do something to make it clear it is over and they need to refresh the page to start a new one
        // we did something like that in V4
        // or perhaps it should have an option where it calls out to the custom webclient theme and it can choose to do something...
        
    }

    componentDidMount(): any {
        this.directLine = this.createDirectLine();
        this.setState({ conversationID: this.props.conversationId });

        let startAuto: boolean = (this.props.startChatAutomatically === "True" || this.props.startChatAutomatically === "true") ? true : false;
        console.log(getTimeStamp() +" - AutoStart:", startAuto)
        if (startAuto) {
            this.initializeSession();
        }   
        $(this.aiFeedbackModalId).on("hidden.bs.modal", this.handleAiFeedbackModalHidden);
        window.addEventListener("message", this.handleAiFeedbackSubmittedMessage);
    }

    componentWillUnmount(): void {
        $(this.aiFeedbackModalId).off("hidden.bs.modal", this.handleAiFeedbackModalHidden);
        window.removeEventListener("message", this.handleAiFeedbackSubmittedMessage);
    }

    handleAiFeedbackModalHidden = () => {
        const iframe = document.getElementById(this.aiFeedbackFrameId) as HTMLIFrameElement | null;
        if (iframe) {
            iframe.src = "about:blank";
        }
    }

    handleAiFeedbackSubmittedMessage = (event: MessageEvent) => {
        if (event.origin !== window.location.origin) {
            return;
        }

        const iframe = document.getElementById(this.aiFeedbackFrameId) as HTMLIFrameElement | null;
        if (!iframe || event.source !== iframe.contentWindow) {
            return;
        }

        const data = event.data as { type?: string } | null;
        if (!data || typeof data !== "object" || data.type !== AI_FEEDBACK_SUBMITTED_MESSAGE) {
            return;
        }

        $(this.aiFeedbackModalId).modal("hide");
    }

    initializeSession = () => {
        console.log(getTimeStamp() +" - Initialize web client session");
        let msgText = "";
        this.directLine?.postActivity(this.patchActivity({
            type: "event",            
            from: { id: this.props.userId, name:this.props.username },
            text: msgText,
            name:"initializeSession"
        })).subscribe(
            (id) => console.log(getTimeStamp() + " - Posted activity, assigned ID: ", id),
            (error) => console.log(getTimeStamp() + " - Error posting activity: ", error)
        );
    };

    handleSubmitCopiedImage = async () => {
        this.sendFiles(this.files);
        this.files = [];
        $(this.sendFileModalId).modal("hide");
    };

    handleCancel = () => {
        this.files = [];
        $(`${this.sendFileModalId} main`).html(); // Clear modal
        $(this.sendFileModalId).modal("hide");
    }

    handlePaste = (event: ClipboardEvent<HTMLDivElement>) => {
        try {
            const files = convertClipboardItemsToFiles(event.clipboardData.items);
            this.confirmAttachments(files);
        } catch (e) {
            console.log(getTimeStamp() + " - Unable to handle the paste event", e);
        }
    }

    handleDrop = (event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        if (!event.dataTransfer) return;
        try {
            const files: _File[] = Array.from(event.dataTransfer.files);
            this.confirmAttachments(files);
        } catch (e) {
            console.log(getTimeStamp() + " - Unable to handle the drop event", e);
        }
    };

    confirmAttachments = (files: (_File)[]) => {
        Promise.all(files.map((file: _File) => {
            if (file.type.includes("image")) {
                return Promise.resolve(readFile(file).then(f => {
                    file.blob = f;
                    return file;
                }));
            }
            return Promise.resolve(file);
        })).then((files) => {
            if (files.length > 0) {
                // Set files
                this.files = this.files.concat(files);
                // Put files in modal (not using this.setState to avoid rerendering ReactWebChat)
                const FileItems = <>{this.files.map((f, i) => <FileItem key={i} file={f} />)}</>;
                $(`${this.sendFileModalId} main`).html(); // Clear modal
                $(`${this.sendFileModalId} main`).html(renderToString(FileItems));
                $(this.sendFileModalId).modal("show"); // Show modal
            }
        }).catch(e => {
            console.log(getTimeStamp() +" - Unable to resolve promises to show attachments modal", e);
        });
    }

    sendFiles = async (files: _File[]) => {
        let _files: DirectLineAttachment[] = [];
        try {
            for await (let file of files) {
                if (file.blob) {
                    const thumbnail = await downscaleImageToDataURLUsingBrowser(file, 425, 425, file.type, 0.75);
                    const blob = await (await fetch(file.blob)).blob();
                    const url = URL.createObjectURL(blob);
                    _files.push({ name: file.name, url: url, thumbnail: thumbnail.toString() });
                } else {
                    const url = URL.createObjectURL(file);
                    _files.push({ name: file.name, url: url, size: file.size });
                }
            }
            this.store.dispatch({ type: "WEB_CHAT/SEND_FILES", payload: { files: _files } });
        } catch (e) {
            console.log(getTimeStamp() +" - Unable to send file.", e);
        }
    };

    isChatRoute = (): boolean => {
        const pathSegments = window.location.pathname
            .toLowerCase()
            .split("/")
            .filter(segment => segment.length > 0);
        const lastSegment = pathSegments[pathSegments.length - 1];
        const previousSegment = pathSegments[pathSegments.length - 2];

        return lastSegment === "chat" || previousSegment === "chat";
    };

    getAiFeedbackModalUrl = (value: string): string | null => {
        if (!this.isChatRoute()) {
            return null;
        }

        let url: URL;
        try {
            url = new URL(value, window.location.href);
        } catch (e) {
            console.warn(getTimeStamp() + " - Unable to parse card action URL", value, e);
            return null;
        }

        if (url.origin !== window.location.origin) {
            return null;
        }

        const pathSegments = url.pathname
            .toLowerCase()
            .split("/")
            .filter(segment => segment.length > 0);
        const lastSegment = pathSegments[pathSegments.length - 1];
        const previousSegment = pathSegments[pathSegments.length - 2];

        if (previousSegment !== AI_RATING_CONTROLLER_SEGMENT || !AI_RATING_ACTIONS.includes(lastSegment)) {
            return null;
        }

        url.searchParams.set("hideNavbar", "true");
        url.searchParams.set(AI_FEEDBACK_MODAL_QUERY_PARAM, "true");
        return url.toString();
    };

    showAiFeedbackModal = (url: string): void => {
        const iframe = document.getElementById(this.aiFeedbackFrameId) as HTMLIFrameElement | null;
        if (!iframe) {
            console.warn(getTimeStamp() + " - AI feedback iframe not found");
            return;
        }

        iframe.src = url;
        $(this.aiFeedbackModalId).modal("show");
    };

    cardActionMiddleware = () => (next: (...args: any[]) => any): ((...args: any[]) => any) => (...args: any[]) => {
        const [{ cardAction } = { cardAction: null }] = args;
        if (cardAction?.type === "openUrl" && typeof cardAction.value === "string") {
            const feedbackUrl = this.getAiFeedbackModalUrl(cardAction.value);
            if (feedbackUrl) {
                this.showAiFeedbackModal(feedbackUrl);
                return;
            }
        }

        return next(...args);
    };

    // TODO Wire up middleware to display 
    /*
    activityMiddleware = () => (next: (arg0: any) => any) => (card: any) => {

        return next(card);
    };
    */
    render(): any {
        if (this.directLine === null) {
            return <div>Loading...</div>;
        }

        const locale = navigator.language;
        const store = this.store;
        return (
            <Droppable onDrop={this.handleDrop}>
                <div className="h-100 w-100" onPaste={this.handlePaste}>
                    <ReactWebChat
                        //activityMiddleware={this.activityMiddleware}
                        cardActionMiddleware={this.cardActionMiddleware}
                        directLine={this.directLine}
                        userID={this.props.userId}
                        username={this.props.username}
                        locale={locale}
                        store={store}
                        styleOptions={this.styleSet}
                    />
                    <SendFilesModal
                        id={this.sendFileModalId.substring(1)}
                        handleSubmit={this.handleSubmitCopiedImage}
                        handleCancel={this.handleCancel}
                    />
                    <AiFeedbackModal
                        id={this.aiFeedbackModalId.substring(1)}
                        iframeId={this.aiFeedbackFrameId}
                    />
                </div>
            </Droppable>
        );
    };  

    playSound(): void { console.log(getTimeStamp() + " - notification sound not implemented yet...") }

    getSoundEnabled(): boolean {
        var soundSettingField = this.props.playNotificationSound;
        if (soundSettingField) {
            return soundSettingField === "true" || soundSettingField === "True";
        }
        return false;
    }  
}

function AiFeedbackModal(props: { id: string, iframeId: string }): JSX.Element {
    return ReactDOM.createPortal(
        <div id={props.id} className="modal fade" tabIndex={-1} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Response feedback</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-0">
                        <iframe
                            id={props.iframeId}
                            title="AI response feedback"
                            className="w-100 border-0"
                            src="about:blank"
                            style={{ height: "70vh" }}
                        />
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}

export default WebChatControl;
